/*
 * @Description: 发送请求
 * @Author: lingmeike
 * @Date: 2019-08-07 15:17:43
 * @LastEditors: lingmeike
 * @LastEditTime: 2019-08-29 17:29:37
 */
import { Toast } from 'antd-mobile';
import loading from './loading';

/**
 *
 * @export
 * @param {*} url 请求url
 * @param {*} [data={}] 请求参数
 * @param {*} [{ fullScreen = false 是否全局loading, showLoading = true, 是否显示loading withoutLogin=false 是否需要登录，默认需要登录, useNative=true, 在客户端里使用客户端请求方法 }={}]
 * @returns
 */
export function request(
  url,
  data = {},
  { fullScreen = false, showLoading = true, withoutLogin = false, useNative = false } = {}
) {
  showLoading && loading.show(fullScreen);

  function shwoError(errMsg) {
    if (fullScreen) {
      loading.error(errMsg || '网络异常');
    } else {
      loading.hide();
      Toast.info(errMsg || '网络异常');
    }
  }

  return window.crgt.request
    .post({
      url,
      params: data,
      useNative,
      withoutLogin,
    })
    .then(res => {
      loading.hide();
      // 未登录或token过期，重新登录, -1011客户端返回未登录
      if (res.code === 14002 || res.code === 14001 || res.code === -1011) {
        window.crgt.router.openLogin().then(res => {
          if (res && res.code === 0) {
            window.location.reload();
          }
        });
      } else if (res.code !== 0) {
        shwoError(res.errmsg || '服务异常');
        return res;
      }

      return res;
    })
    .catch(error => {
      shwoError();
      console.warn(error);
    });
}

export default request;
